import { render, staticRenderFns } from "./PreviewFormsPPM.vue?vue&type=template&id=76877fc5"
import script from "./PreviewFormsPPM.vue?vue&type=script&lang=ts"
export * from "./PreviewFormsPPM.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports